import { get } from '../index';

export const getFilterView = () => {
  return get('/filter');
};

export const getFilterByCompanyId = (companyId) => {
    return get(`/filter/company/${companyId}`);
  };

  export const getFilterByProjectId = (projectId, timelineId) => {
    return get(`/filter/project/${projectId}/${timelineId}`);
  };

// Every saved filter the company has, of BOTH kinds - timeline filters and
// company tracking rule sets - already tagged with which kind each row is.
// The company comes from the signed-in user on the server; there is no
// parameter to pass one.
export const getSavedFilters = () => {
  return get('/filter/saved');
};
